/** @jsxImportSource @emotion/react */
import React from 'react';
import PageTemplate from '@page/admin/page-template';
import StudentHome from '@component/admin/student/student-home';

const StudentListPage: React.FC = () => {
  return (
    <PageTemplate title='학생 관리'>
      <StudentHome />
    </PageTemplate>
  );
};

export default StudentListPage;
